export const BackedByADTIcon = ({
  title = "Backed by ADT",
  width = 80,
  height = 80,
  ...props
}: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    {...props}>
    <title>{title}</title>
    <path
      stroke="#00226A"
      strokeMiterlimit={10}
      d="M41.622 14.165c-13.55 0-25.556 10.9-23.714 24.533 1.654 12.235 7.354 14.854.311 24.362l3.962.345c3.61.316 7.239.266 10.839-.145l2.257-.258M41.622 14.165c13.549 0 25.555 10.9 23.713 24.533-1.654 12.235-7.354 14.854-.311 24.362l-3.962.345a53.967 53.967 0 0 1-10.839-.145l-1.654-.258"
    />
    <path
      stroke="#00226A"
      strokeMiterlimit={10}
      d="M59.444 39.388c-.602 14.468-8.269 25.905-17.64 25.905-9.37 0-17.681-12.427-17.681-27.76v-.353c1.447.233 2.927.354 4.436.354a27.644 27.644 0 0 0 17.81-6.465 27.755 27.755 0 0 0 13.075 8.319Z"
    />
    <path
      stroke="#00226A"
      strokeMiterlimit={10}
      d="M44.748 55.298c.698 2.49 5.342 3.36 10.364 1.946 2.807-.79 5.135-2.12 6.523-3.58"
    />
    <path
      fill="#00226A"
      d="M45.093 59.63a3.471 3.471 0 1 0 0-6.943 3.471 3.471 0 0 0 0 6.943Z"
    />
    <path
      stroke="#5DCDFF"
      strokeMiterlimit={10}
      d="M39.489 44.904a4.459 4.459 0 0 1-4.461 4.46c-2.466 0-6.79-3.325-6.79-5.79 0-2.466 4.329-3.13 6.79-3.13a4.461 4.461 0 0 1 4.46 4.46ZM43.962 44.904a4.459 4.459 0 0 0 4.46 4.46c2.466 0 6.79-3.325 6.79-5.79 0-2.466-4.328-3.13-6.79-3.13a4.461 4.461 0 0 0-4.46 4.46ZM24.123 44.16h4.112M55.216 44.16h4.112M39.726 44.16h4.116"
    />
  </svg>
);
